module.exports = __webpack_public_path__ + "img/1545809185.856077e6.jpg";